// import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CardProject from './CardProject';
import { projects } from '../data/projects';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import '../styles/Project.css';


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "#023535", overflow: "hidden", borderRadius: "9px" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "#023535", overflow: "hidden", borderRadius: "9px" }}
      onClick={onClick}
    />
  );
}

export default class Projects extends Component {

  state = {tec: ''};

  handleChange = ({target}) => {
    const { value } = target;
    this.setState({ tec: value });
  };

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      initialSlide: 0,
      cssEase: "linear",
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    const { tec } = this.state;
    return (
      <section id='projetos' className="animate__animated animate__slideInUp">
        <h3 className="title-projects">Projetos</h3>
        <input type="text" placeholder='Pesquise por tecnologias' value={ tec } onChange={ this.handleChange }/>
        <div className="project-container">
          <Slider {...settings}>
          { projects.filter(project => {
          if (tec === '') return project
          return project.tecnologies.some(tecnologie => tecnologie.toLowerCase().includes(tec.toLowerCase()))
        }).map((project, index) => (
          <CardProject key={index} projects={ project } />
        ))}
          </Slider>

        </div>
      </section>
    )
  };
};
